import lazyLoading from './lazyLoading';

export default {
  name: 'FAQ',
  path: '/park/faq/:id?',
  component: lazyLoading('parkec/PARK_Faq'),
  meta: {
    title: 'schema.park_faqs',
    iconClass: 'far fa-question-circle',
    to: '/park/faq',
    auth: 'admin',
  },
  props: r => ({root: true, id: r.params.id}),
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/faq.js